import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const ButtonBarDiv = styled.div`
    min-height: 45px;
    background: #F6F8FA;
    border-top: 1px solid ${Color.Grey.G20};
    bottom: 0;
    right: 0;
    left: 0;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    z-index: 10;
`;

export const ButtonBarModalDiv = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const ButtonBarButton = styled.div`
    display: block;
`;

export const ButtonBarCenter = styled.div`
    justify-content: center;
    display: flex;
    flex: 1;
    ${ButtonBarButton} + ${ButtonBarButton} {
        padding-left: 10px;
    }
`;

export const ButtonBarRight = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    ${ButtonBarButton} + ${ButtonBarButton} {
        padding-left: 10px;
    }
`;

export const ButtonBarLeft = styled.div`
    display: flex;
    flex: 1;
    ${ButtonBarButton} + ${ButtonBarButton} {
        padding-left: 10px;
    }
`;
